/* CacheBuster component */
import React from 'react'
import semver from 'semver'
export default class CacheBuster extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...')
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then((names) => {
            for (const name of names) caches.delete(name)
          })
        }
        // delete browser cache and hard reload
        window.location.reload(true)
      },
    }
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'development') {
      console.log('In development, no need for cache checking')
      this.setState({ loading: false, isLatestVersion: true })
      return
    }

    fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
      .then(async (response) => response.json())
      .then((meta) => {
        const currentVersion = import.meta.env.PACKAGE_VERSION
        const latestVersion = meta.version

        console.log(`Current: ${currentVersion}, Latest: ${latestVersion}, cache: ${JSON.stringify(caches)}`)

        if (semver.gt(latestVersion, currentVersion)) {
          console.log(`We have a new version - ${latestVersion}. Should force refresh`)
          this.setState({ loading: false, isLatestVersion: false })
        } else {
          console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`)
          this.setState({ loading: false, isLatestVersion: true })
        }
      })
      .catch((error) => {
        console.log('no meta')
        this.setState({ loading: false, isLatestVersion: true })
      })
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload })
  }
}
